import i18n from '@/i18n'
import store from '@/store'
import { UserActionTypes } from '@/store/modules/users/actions'
import { SCRIPTS__FETCH } from '@/store/actions'
import { EKanbanKeys } from '@/constants/dataTable'

export interface Column {
  key: EKanbanKeys
  values: string[]
  titles: string[]
}

export interface Option {
  [key: string]: string
}

export let columns: Column[]

export async function columnConstants() {
  const finishTypeValues = ['1', '2', '3', '4', '5', '6']
  const finishType = {
    key: EKanbanKeys.finishType,
    values: finishTypeValues,
    titles: finishTypeValues.map(elem => i18n.tc(`records.finishType.${elem}`)),
  }
  const targetValues = ['true', 'false']
  const target = {
    key: EKanbanKeys.target,
    values: targetValues,
    titles: targetValues.map(elem => i18n.tc(`records.targetValue.${elem}`)),
  }

  await store.dispatch(UserActionTypes.FetchCompanyUsers)
  const usersIds: string[] = store.getters.getUsersFilteredList.map(
    (elem: Option) => elem.id,
  )
  const userNames: string[] = store.getters.getUsersFilteredList.map(
    (elem: Option) => `${elem.fname} ${elem.lname}`,
  )
  const users: Column = {
    key: EKanbanKeys.userName,
    values: usersIds,
    titles: userNames,
  }

  await store.dispatch(SCRIPTS__FETCH)
  const scriptsIds: string[] = store.getters.getScriptsList.map(
    (elem: Option) => elem.id,
  )
  const scriptTiltles: string[] = store.getters.getScriptsList.map(
    (elem: Option) => `${elem.title}`,
  )
  const scripts = {
    key: EKanbanKeys.scriptName,
    values: scriptsIds,
    titles: scriptTiltles,
  }
  columns = [finishType, target, users, scripts]
}
